import { getHourAndMinutes } from "../../../main/themes/defaultLayout";

export function getChartHourLabel(dateTime?: string): string {
  if (!dateTime) {
    return "";
  }

  const isoTimeMatch = dateTime.match(/T(\d{2}:\d{2})/);
  if (isoTimeMatch?.[1]) {
    return isoTimeMatch[1];
  }

  return getHourAndMinutes(dateTime);
}

export function alignSeriesValuesByDateTime<
  T extends { dateTime?: string; value?: number },
>(reference?: T[], values?: T[]): number[] {
  if (!reference?.length) {
    return [];
  }

  const valueByDateTime = new Map(
    values?.map((item) => [item.dateTime ?? "", item.value ?? 0]) ?? [],
  );

  return reference.map((ref) => valueByDateTime.get(ref.dateTime ?? "") ?? 0);
}

export function mapSeriesXLabels<
  T extends { dateTime?: string },
>(items?: T[]): string[] {
  return items?.map((item) => getChartHourLabel(item.dateTime)) ?? [];
}

export function mapSeriesValues<
  T extends { value?: number },
>(items?: T[]): number[] {
  return items?.map((item) => item.value ?? 0) ?? [];
}

export function getInitialSliderRange(
  length: number,
  startWithFullRange?: boolean,
): [number, number] {
  if (length === 0) {
    return [1, 0];
  }

  const max = length;
  const min = startWithFullRange ? 1 : Math.max(1, max - 30);
  return [min, max];
}
